/*
These functions make sure WordPress
and Foundation play nice together.
*/
jQuery(document).ready(function() {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
	
	jQuery('#tab-link-list a[href^="#"]').each(function(){ 
		jQuery(this).off('click');
		var oldUrl = jQuery(this).attr("href"); // Get current url
		var newUrl = oldUrl.replace("#", "/"); // Create new url
		jQuery(this).attr("href", newUrl); // Set herf value
	});

	// Prevent default code from producing two H1s on page.
	jQuery('.floating-product-cta h1').replaceWith(function() { return '<h2 class="bc-product__title">' + this.innerHTML + '</h2>'; });

	jQuery('.bc-product-form__quantity-input').attr('title', 'product quantity');

	// floating element script
	if (jQuery("#main").length) {
		jQuery(window).bind('scroll', function() {
			if(jQuery(window).scrollTop() >= jQuery('#main').offset().top + jQuery('#main').outerHeight() - window.innerHeight) {
			jQuery('.im-stuck').css("position", "static");
			} else {
			jQuery('.im-stuck').css("position", "fixed");
			}
		});
	}

	//ada fixes
	jQuery("img[title='Lucky Orange Chat Logo']").removeAttr('style');
	jQuery('form').attr('role', 'button');
	jQuery('#testimonial-slider:eq(1)').remove();
	jQuery('iframe').attr('title', 'acls video iframe');

}); 

